module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Hide this message":"Nachricht verstecken"}}')
  delete Component.options._Ctor
}
